<template>
  <section>
    <div class="intro-y flex items-center mt-8">
        <h2 class="text-lg font-medium mr-auto">
            Perfil
        </h2>
    </div>
    <div v-if="loading">
      <!-- BEGIN: Profile Info -->
      <div class="intro-y box px-5 pt-5 mt-5">
          <div class="flex flex-col lg:flex-row border-b border-gray-200 pb-5 -mx-5">
              <div class="flex flex-1 px-5 items-center justify-center lg:justify-start">
                  <div class="w-20 h-20 sm:w-24 sm:h-24 flex-none lg:w-32 lg:h-32 image-fit relative">
                      <img alt="Profile" class="rounded-full" :src="user.avatar" v-if="user && user.avatar">
                      <img alt="Profile" class="rounded-full" src="/static/images/profile.png" v-else>
                  </div>
                  <div class="ml-5">
                      <div class="truncate sm:whitespace-normal font-medium text-lg">{{user.name}}</div>
                      <div class="text-gray-600 mb-4">{{user.email}}</div>
                      <form>
                        <input type="file" class="hidden" id="file" @change="onFileChange" accept="image/png, image/jpeg">
                        <div class="text-left" v-if="loadImage">
                          <strong><i class="fa fa-spinner fa-spin"></i> Cargando...</strong>
                        </div>
                        <label for="file" class="button bg-theme-10 text-white button-sm" v-else>
                            <i class="fa fa-plus"></i> Cambiar Foto
                        </label>
                      </form>
                  </div>
              </div>
              <div class="flex mt-6 lg:mt-0 items-center lg:items-start flex-1 flex-col justify-center text-gray-600 px-5 border-l border-r border-gray-200 border-t lg:border-t-0 pt-5 lg:pt-0">
                  <div class="truncate sm:whitespace-normal flex items-center" v-if="user.profile">
                    {{user.profile.name}}
                  </div>
                  <div class="truncate sm:whitespace-normal flex items-center mt-3" v-if="user.team">
                    {{user.team.name}}
                  </div>
                  <div class="truncate sm:whitespace-normal flex items-center mt-3">
                    <b>ID compañia:</b> &nbsp; {{user.id_company}}
                  </div>
                  <div class="truncate sm:whitespace-normal flex items-center mt-3">
                    <b>Ingreso:</b> &nbsp; {{ user.admission_date }}
                  </div>
                  <div class="truncate sm:whitespace-normal flex items-center mt-3">
                    <b>Nacimiento:</b> &nbsp; {{ user.birthday }}
                  </div>
                  <div class="truncate sm:whitespace-normal flex items-center mt-3">
                      Estas en MYINXAIT desde el {{ user.created_at }}
                  </div>
              </div>
              <div class="w-20 h-20 px-5 sm:w-24 sm:h-24 mr-5 flex-none lg:w-32 lg:h-32 relative border-l hidden-xs border-gray-200" 
                  v-if="user.team_id">
                    <img alt="Team" class="mt-4" 
                      :src="'https://storage.googleapis.com/myinxait/teams/team-'+user.team_id+'.png'">
              </div>
          </div>
          <div class="nav-tabs flex flex-col sm:flex-row justify-center lg:justify-start hidden">
              <a data-toggle="tab" data-target="#profile" href="javascript:;" class="py-4 sm:mr-8 flex items-center active"> <i class="w-4 h-4 mr-2" data-feather="user"></i> Profile </a>
              <a data-toggle="tab" data-target="#account" href="javascript:;" class="py-4 sm:mr-8 flex items-center"> <i class="w-4 h-4 mr-2" data-feather="shield"></i> Account </a>
              <a data-toggle="tab" data-target="#change-password" href="javascript:;" class="py-4 sm:mr-8 flex items-center"> <i class="w-4 h-4 mr-2" data-feather="lock"></i> Change Password </a>
              <a data-toggle="tab" data-target="#settings" href="javascript:;" class="py-4 sm:mr-8 flex items-center"> <i class="w-4 h-4 mr-2" data-feather="settings"></i> Settings </a>
          </div>
      </div>
      <!-- END: Profile Info -->
    </div>

    <app-loading v-else />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminProfile',
  data () {
    return {
      loadImage: false,
      loading: false,
      view: {
        entity: 'user'
      },
      file: null,
      aux_user: { entity: 'user' }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  beforeMount () {
    this.loading = true
  },
  methods: {
      async changeAvatar () {
        var vm = this
        vm.loading = true

        const formData = new FormData()
        formData.append('id', vm.user.id)
        formData.append('entity', 'user')
        formData.append('image', this.file)

        await vm.store(formData).then(user => {
          vm.loadImage = false
          window.location.reload()
        })
        .catch(message => {
          console.log('error', message)
          vm.loadImage = false
        })
      },
      onFileChange (e) {
        console.log('onfile')
        this.loadImage = true
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        var file = files[0]
        this.file = e.target.files[0]
        this.changeAvatar()
      },
      ...mapActions([
        'show',
        'store'
      ])
  },
  components: {
    appLoading : Loading
  }
}
</script>



// WEBPACK FOOTER //
// AdminProfile.vue?3259bf15